const ListIcon = ({ isActive }) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_1264_20708"
        style={{
          maskType: 'alpha',
        }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="17"
        height="17"
      >
        <rect x="0.5" y="0.973877" width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1264_20708)">
        <path
          d="M6.5 13.6405V12.3072H14.5V13.6405H6.5ZM6.5 9.64054V8.30721H14.5V9.64054H6.5ZM6.5 5.64054V4.30721H14.5V5.64054H6.5ZM3.83333 14.3072C3.46667 14.3072 3.15278 14.1767 2.89167 13.9155C2.63056 13.6544 2.5 13.3405 2.5 12.9739C2.5 12.6072 2.63056 12.2933 2.89167 12.0322C3.15278 11.7711 3.46667 11.6405 3.83333 11.6405C4.2 11.6405 4.51389 11.7711 4.775 12.0322C5.03611 12.2933 5.16667 12.6072 5.16667 12.9739C5.16667 13.3405 5.03611 13.6544 4.775 13.9155C4.51389 14.1767 4.2 14.3072 3.83333 14.3072ZM3.83333 10.3072C3.46667 10.3072 3.15278 10.1767 2.89167 9.91554C2.63056 9.65443 2.5 9.34054 2.5 8.97387C2.5 8.60721 2.63056 8.29332 2.89167 8.03221C3.15278 7.7711 3.46667 7.64054 3.83333 7.64054C4.2 7.64054 4.51389 7.7711 4.775 8.03221C5.03611 8.29332 5.16667 8.60721 5.16667 8.97387C5.16667 9.34054 5.03611 9.65443 4.775 9.91554C4.51389 10.1767 4.2 10.3072 3.83333 10.3072ZM3.83333 6.30721C3.46667 6.30721 3.15278 6.17665 2.89167 5.91554C2.63056 5.65443 2.5 5.34054 2.5 4.97387C2.5 4.60721 2.63056 4.29332 2.89167 4.03221C3.15278 3.7711 3.46667 3.64054 3.83333 3.64054C4.2 3.64054 4.51389 3.7711 4.775 4.03221C5.03611 4.29332 5.16667 4.60721 5.16667 4.97387C5.16667 5.34054 5.03611 5.65443 4.775 5.91554C4.51389 6.17665 4.2 6.30721 3.83333 6.30721Z"
          fill={isActive ? '#00cf83' : '#89D3B8'}
        />
      </g>
    </svg>
  )
}

export default ListIcon
